import { useQueryParams } from '../../../../../core/router'

export const getEncodedSkuId = () => {
  const typeName = 'User'
  const skuId = useQueryParams().get('skuId')
  const encodedSkuId = btoa(`${typeName}-${skuId}`)

  return encodedSkuId
}
